import request from '@/utils/request'

export function fetchAreaList(data) {
  return request({
    url: '/v1/region/get-region',
    method: 'get',
    params: data
  })
}

export function fetchSchoolList(data) {
  return request({
    url: '/v1/provider/register/list',
    method: 'post',
    data
  })
}

export function fetchCustomList(data) {
  return request({
    url: '/v1/contents/fe-action',
    method: 'post',
    data
  })
}

export function fetchRecommendList(data) {
  return request({
    url: '/v1/contents/fe-recommend',
    method: 'post',
    data
  })
}
